'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from './useDecisions';
export const useAutoshipDecisions = () => {
  const $ = _c(3);
  const autoshipType = useDecisions("ff_autoship");
  const t0 = autoshipType === "crawl";
  const t1 = autoshipType === "precrawl";
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      isAutoshipCrawl: t0,
      isAutoshipPreCrawl: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};